<!-- 会签或签-->
<template>
  <div class="countersign-box-item" :class="{'last-countersign-box-item':isLastElement}">
    <div class="countersign-box-item-line"></div>
    <div class="countersign-box-item-head">
      <img src="@/assets/images/countersign-head.png" />
      <div class="status"></div>
    </div>
    <div class="countersign-box-item-main">
      <div class="title-time">
        <div class="title">审批人</div>
        <div class="time"></div>
      </div>
      <div class="author">
        <span>{{approvalInfo.jointlyApprovalList.length}}人{{approvalInfo.jointlyApprovalList.length>0?approvalInfo.jointlyApprovalList[0].approverWay==1?'会签':'或签' :''}}（审批中）</span>
      </div>
      <div class="content">
        <div
          v-for="(item,index) in approvalInfo.jointlyApprovalList"
          :key="index"
          @click="$parent.openProfile(item.dingDingUserId)"
          class="content-item"
        >
          <div>
            <img
              :src="(item.dingDingPhotoPath&&item.dingDingPhotoPath.length>0)?item.dingDingPhotoPath:require('@/assets/images/defaultHead.png')"
            />
          </div>
          <div>{{item.employeeName}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isLastElement: false,
    approvalInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>
<style lang="less" scoped>
.last-countersign-box-item {
  padding-bottom: 0.4rem !important;
  .countersign-box-item-line {
    width: 0 !important;
  }
}
.countersign-box-item {
  width: 100%;
  display: flex;
  position: relative;
  padding-bottom: 1rem;

  .countersign-box-item-line {
    position: absolute;
    left: 0.6667rem;
    height: 100%;
    width: 0.0267rem;
    background: #ffe2a9;
    z-index: 7;
  }
  .countersign-box-item-head {
    z-index: 8;
    width: 1.3333rem;
    height: 1.3333rem;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    .status {
      width: 0.3733rem;
      height: 0.3733rem;
      position: absolute;
      bottom: 0;
      right: 0;
      border-radius: 50%;
      border: 0.0267rem solid #fff;
      background: url("../../../assets/icon/deng.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .countersign-box-item-main {
    flex: 1;
    margin-left: 0.2667rem;
    .title-time {
      display: flex;
      .time {
        font-size: 0.2933rem;
        color: #999999;
      }
      .title {
        flex: 1;
        font-size: 0.4533rem;
        color: #2c2c2c;
        font-weight: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
    .author {
      margin-top: 0.2667rem;
      font-size: 0.3467rem;
      color: #666666;
    }
    .content {
      width: 100%;
      margin-top: 0.2667rem;
      display: flex;
      flex-wrap: wrap;
      align-content: center;
      .content-item {        
        margin-right: 0.453333rem;
        font-size: 0.266rem;
        color: #666666;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        -webkit-box-align: center;
        align-items: center;
        img {
          width: 0.8rem;
          height: 0.8rem;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Approval/ApprovalProcess/approvalCountersign.vue